import React, { lazy, Suspense } from 'react';
import { MapTo } from '@adobe/aem-react-editable-components';
import { AEM_FUNCTIONS } from '@yme/common/aem-functions';
import { withTranslation } from '@yme/services/i18n';
import { FormSkeleton } from '../LeadForm/FormSkeleton';
import { isMaintenanceFormEmpty } from './helpers';
const MaintenanceForm = lazy(() => import('./MaintenanceForm'));
const maintenanceFormEditConfig = {
    emptyLabel: 'MaintenanceForm',
    isEmpty: isMaintenanceFormEmpty,
};
function MaintenanceFormWrapper(props) {
    return (React.createElement(Suspense, { fallback: !props.isInEditor ? React.createElement(FormSkeleton, null) : null },
        React.createElement(MaintenanceForm, { ...props })));
}
export default MapTo(AEM_FUNCTIONS.maintenanceForm)(withTranslation(MaintenanceFormWrapper, ['nearestDealersModel.labels']), maintenanceFormEditConfig);
